// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource'

Vue.use(VueResource)

// Vue.prototype.$url_name = 'http://localhost:8000/fr/api/v1'
// Vue.prototype.$url_name = 'https://mariaexpress.us.aldryn.io/fr/api/v1'
Vue.prototype.$url_name = 'https://mariaexpress.ca/fr/api/v1'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js